import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../../../components/button'
import Cashfree from '../../../components/cashfree'
import LoadingIndicator from '../../../components/loadingIndicator'
import Text from '../../../components/text'
import { useAxios } from '../../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../../core/GlobalContext'
import { REQUEST_STATUS, ROUTES } from '../../../core/actions'
import { INR, TRADECRED_SUPPORT_EMAIL } from '../../../core/constants'
import { currencyParser } from '../../../utils/misc'
import { fetchWalletAction } from '../../financier/FinancierDuck'
import * as styles from './Deposit.css'
import { useAuth } from '../../../core/AuthContext'

export const Deposit = () => {
  const { authAxios } = useAxios()
  const { authState } = useAuth()
  const {
    financierState: { financier, status },
  } = useGlobal()
  const { financierDispatch } = useGlobalDispatch()
  const navigate = useNavigate()

  const handleBackPress = () => navigate(ROUTES.OVERVIEW)

  useEffect(() => {
    fetchWalletAction()(authAxios, financierDispatch)
  }, [])

  return (
    <div className={styles.deposit}>
      <div className={styles.header}>
        <Button handleClick={handleBackPress} type='icon'>
          <ion-icon name='arrow-back-outline' />
        </Button>
        <Text size='1.5' color='var(--ib-ink)' bold className={styles.title}>
          Deposit {INR} to wallet
        </Text>
      </div>
      <Text size='0.8' color='var(--ib-muted)' className={styles.subLine}>
        Deposit money from your bank account to your Escrow Account (Income Bazaar Wallet)
      </Text>
      <div className={styles.divider} />

      {status === REQUEST_STATUS.PENDING ? (
        <LoadingIndicator />
      ) : financier?.escrow?.accountNumber ? (
        <div className={styles.depositDetails}>
          <div className={styles.availableBalance}>
            <span className={styles.balanceLabel}>Available Wallet Balance</span>
            <span className={styles.balanceValue}>{currencyParser(financier?.walletBalance)}</span>
          </div>
          {/* HIDDEN (do not delete): the Cashfree UPI/Netbanking deposit + its 48-hour
              note are hidden because the Cashfree gateway is currently unavailable. To
              restore, change `false` back to `true` below. NEFT/RTGS deposit stays live. */}
          {false && (
            <>
              {/* Disabling Cashfree Deposit on DBS */}
              {authState?.baseUrl?.includes('dbs') ? (
                <Text size='0.9' className={styles.instr}>
                  Netbanking & UPI is unavailable for now. Please use NEFT/RTGS for depositing funds. We apologize for the
                  inconvenience
                </Text>
              ) : (
                <>
                  <span className={styles.fieldLabel}>To deposit via UPI or Netbanking</span>
                  <div className={styles.amountRow}>
                    <Cashfree type='Deposit' enabled={true} />
                  </div>
                </>
              )}

              <Text size='0.8' color='var(--ib-muted)' className={styles.noteMuted}>
                Note: Amount may take{' '}
                <Text size='0.8' color='var(--ib-ink)' bold>
                  up to 48 hours
                </Text>{' '}
                to reflect in your wallet
              </Text>
            </>
          )}
          <div className={styles.divider} />

          <div className={styles.warn}>
            <ion-icon name='alert-circle-outline' style={{ fontSize: '1.15rem', flex: 'none' }} />
            <span>Please do not use IMPS</span>
          </div>
          <Text size='0.9' className={styles.instr}>
            For <strong>NEFT or RTGS</strong> transfers, add your escrow account as
            <strong> Other Bank Beneficiary</strong> in your bank account
          </Text>

          <div className={styles.escrowCard}>
            <span className={styles.escrowTitle}>Your Escrow Account Details</span>
            <div className={styles.attrGrid}>
              <div className={styles.attr}>
                <span className={styles.attrLabel}>Beneficiary Name</span>
                <span className={styles.attrValue}>{financier?.escrow?.holderName}</span>
              </div>
              <div className={styles.attr}>
                <span className={styles.attrLabel}>Account Number</span>
                <span className={styles.attrValue}>{financier?.escrow?.accountNumber}</span>
              </div>
              <div className={styles.attr}>
                <span className={styles.attrLabel}>Bank Name</span>
                <span className={styles.attrValue}>{financier?.escrow?.bankName}</span>
              </div>
              <div className={styles.attr}>
                <span className={styles.attrLabel}>IFSC</span>
                <span className={styles.attrValue}>{financier?.escrow?.IFSC}</span>
              </div>
              <div className={styles.attr}>
                <span className={styles.attrLabel}>Account Type</span>
                <span className={styles.attrValue}>Current Account</span>
              </div>
            </div>
          </div>
          <div className={styles.divider} />

          <Text size='0.8' color='var(--ib-muted)' className={styles.footerNote}>
            In case the amount is not credited within 48 hours, please reach out to us at {TRADECRED_SUPPORT_EMAIL}{' '}
            before raising dispute with your bank.
          </Text>
        </div>
      ) : (
        <div className={styles.depositDetails}>
          <Text size='0.95' color='var(--ib-ink)' bold>
            Oops! We couldn&apos;t find your escrow account details
          </Text>
          <Text size='0.9' color='var(--ib-muted)' className={styles.instr}>
            Please send an email to {TRADECRED_SUPPORT_EMAIL} and ask them to allot an escrow bank account to your
            account.
          </Text>
        </div>
      )}
    </div>
  )
}
